import React, { useEffect } from 'react'
import {
  Btn,
  CustomCalendar,
  CustomCheckbox,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  InputText,
  InputTime,
} from '../../../../../components'
import * as colors from '../../../../../assets/js/colors'
import { formatarDataHora } from '../../shared/respostas.util'
import useModalPreenchimento, {
  incluirOpcao,
  LIMITES,
  montarPayload,
  validar,
} from './ModalPreenchimentoHook'

const styles = {
  checkbox: { display: 'flex', alignItems: 'flex-end', paddingBottom: 15 },
  dica: { color: colors.gray, fontSize: '0.8rem', marginTop: 5 },
}

export default function ModalPreenchimento({
  show,
  preenchimento,
  formInit,
  onClose,
  onSave,
  onError,
}) {
  const { state, localDispatch } = useModalPreenchimento()
  const { form, empresas } = state

  useEffect(() => {
    if (show) localDispatch.start(preenchimento, formInit)
  }, [show, preenchimento, formInit])

  const edicao = !!preenchimento
  const onChange = localDispatch.onChange

  const checklists = incluirOpcao(formInit.checklists, form.checklist).map(c => ({
    ...c,
    label: `${c.checklist_code} - ${c.title}`,
  }))
  const companies = incluirOpcao(empresas, form.company)
  const users = incluirOpcao(formInit.users, form.responsavelUser)

  const onBtnSalvarClicked = () => {
    const erro = validar(form, preenchimento)
    if (erro) return onError(erro)

    onSave(montarPayload(form, preenchimento))
  }

  return (
    <CustomModal
      header={edicao ? 'Editar Preenchimento de Checklist' : 'Novo Preenchimento de Checklist'}
      isVisible={show}
      onClose={onClose}
      width="800px"
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomDropdown
            label="Formulário:*"
            optionLabel="label"
            options={checklists}
            value={checklists.find(c => form.checklist && c.id === form.checklist.id) || null}
            onChange={value => onChange('checklist', value)}
            disabled={edicao}
            placeholder="Selecione o formulário"
            filter
          />
          {edicao ? (
            <div style={styles.dica}>
              O formulário não pode ser alterado após a criação do preenchimento.
            </div>
          ) : null}
        </div>

        <div className="p-col-12">
          <CustomDropdown
            label="Empresa:"
            optionLabel="name"
            options={companies}
            value={form.company}
            onChange={value => onChange('company', value)}
            placeholder="Selecione a empresa (opcional)"
            showClear
            filter
          />
        </div>

        <div className="p-md-7 p-col-12">
          {form.semUsuario ? (
            <InputText
              label="Nome do Responsável pelo preenchimento:*"
              marginTop={9}
              maxLength={LIMITES.responsavelNome}
              value={form.responsavelNome}
              onChange={value => onChange('responsavelNome', value)}
            />
          ) : (
            <CustomDropdown
              label="Responsável pelo preenchimento:*"
              optionLabel="name"
              options={users}
              value={form.responsavelUser}
              onChange={value => onChange('responsavelUser', value)}
              placeholder="Selecione o usuário"
              filter
            />
          )}
        </div>
        <div className="p-md-5 p-col-12" style={styles.checkbox}>
          <CustomCheckbox
            checked={form.semUsuario}
            onChange={value => onChange('semUsuario', value)}
          >
            Responsável não possui usuário cadastrado
          </CustomCheckbox>
        </div>

        <div className="p-md-5 p-col-12" style={styles.checkbox}>
          <CustomCheckbox
            checked={form.comDeadline}
            onChange={value => onChange('comDeadline', value)}
          >
            Definir Deadline
          </CustomCheckbox>
        </div>
        {form.comDeadline ? (
          <>
            <div className="p-md-4 p-col-12">
              <CustomCalendar
                label="Data:*"
                value={form.deadlineData}
                onChange={value => onChange('deadlineData', value)}
              />
            </div>
            <div className="p-md-3 p-col-12">
              <InputTime
                label="Hora:*"
                marginTop={10}
                value={form.deadlineHora}
                onChange={value => onChange('deadlineHora', value)}
              />
            </div>
          </>
        ) : (
          <div className="p-md-7 p-col-12" />
        )}
        {edicao && preenchimento.created_at ? (
          <div className="p-col-12" style={styles.dica}>
            Criado em {formatarDataHora(preenchimento.created_at)}. O deadline não pode ser anterior
            à criação.
          </div>
        ) : null}

        <div className="p-col-12">
          <CustomInputTextArea
            label="Observação"
            rows={3}
            value={form.observacao}
            onChange={value => onChange('observacao', value)}
          />
        </div>

        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}
